"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("./_internal/Icon"));
var CloseOutlined = /*#__PURE__*/_react["default"].forwardRef(function (ddProps, ref) {
  var props = {};
  var svg = /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    className: "dt__icon",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M843.861 180.139a42.667 42.667 0 012.176 58.005l-2.176 2.347L572.331 512l271.53 271.53a42.667 42.667 0 01-58.005 62.507l-2.347-2.176L512 572.331 240.47 843.86a42.667 42.667 0 01-62.507-58.005l2.176-2.347L451.627 512 180.139 240.47a42.667 42.667 0 0158.005-62.507l2.347 2.176L512 451.627l271.53-271.488a42.667 42.667 0 0160.331 0z"
  }));
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, ddProps, {
    svg: svg,
    ref: ref
  }));
});
CloseOutlined.displayName = "CloseOutlined";
var _default = exports["default"] = CloseOutlined;